module.exports = __webpack_public_path__ + "assets/images/img/02.2938a333d5f127fecbba17aafbe36091.jpg";